export default "__VITE_ASSET__BQLvfP4T__"